import { create } from "zustand";

/**
 * Shared selection for the IoT Company filter visible only to admins.
 * Mirrors the Vue `useCompanyFilter` singleton — when an admin picks a
 * company, all data fetches across the app should respect that scope.
 *
 * Conventions:
 *  - "" (empty string) means "no filter" → show all companies (admin only).
 *  - A populated string means "filter to this company".
 *  - Non-admin users ignore the store and always use their own `iotCompany`.
 */
interface CompanyFilterState {
  selectedCompany: string;
  setSelectedCompany: (company: string) => void;
  reset: () => void;
}

export const useCompanyFilterStore = create<CompanyFilterState>((set) => ({
  selectedCompany: "",
  setSelectedCompany: (company) => set({ selectedCompany: company }),
  reset: () => set({ selectedCompany: "" }),
}));

export const selectSelectedCompany = (s: CompanyFilterState) =>
  s.selectedCompany;
